import styled from 'styled-components';
import {Link} from 'gatsby';

export const FormWrapper = styled.div`
  width: 100%;
  background: #afa3c0;
  display: flex;
  /* align-items: center; */
`;

export const FormFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
  }
`;

export const FormColumn = styled.div`
  width: 50%;
  padding: 70px;

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0 40px 40px 40px;

    &:last-of-type {
      padding: 40px 40px 0 40px;
    }
  }

  @media (max-width: 768px) {
    padding: 0 20px 20px 20px;

    &:last-of-type {
      padding: 20px 20px 0 20px;
    }
  }
`;

export const FormTitle = styled.h3`
  color: #fff;
  font-family: 'LATOLIGHT';
  font-size: 1.2rem;
  text-transform: uppercase;
  margin: 0 0 1rem;
  margin-left: 1rem;

  @media (max-width: 1024px) {
    text-align: center;
    margin-top: 1rem;
  }
`;

export const FormContainer = styled.div`
  border-radius: 10px;
  border: 3px solid #fff;
  display: flex;
  flex-direction: column;
`;

export const FormInput = styled.input`
  color: #fff;
  background: transparent;
  font-family: 'LATOREGULAR';
  padding: 0.5rem;
  border: none;
  outline: #fff;
  width: 100%;
  font-size: 0.7rem;
  border-bottom: 3px solid #fff;

  &::placeholder {
    color: #fff;
  }
`;

export const FormTextarea = styled.textarea`
  color: #fff;
  background: transparent;
  font-family: 'LATOREGULAR';
  padding: 0.5rem;
  border: none;
  outline: #fff;
  width: 100%;
  height: 7rem;
  font-size: 0.7rem;
  resize: none;
  border-bottom: 3px solid #fff;

  &::placeholder {
    color: #fff;
  }
`;

export const FormAgree = styled.div`
  color: #fff;
  background: transparent;
  font-family: 'LATOREGULAR';
  padding: 0.5rem;
  border: none;
  outline: #fff;
  width: 100%;
  font-size: 0.7rem;
  /* border-bottom: 3px solid #fff; */
  display: flex;
  align-items: center;
  justify-content: space-between;

  input {
    width: 20px;
    height: 20px;
  }

  p {
    margin-left: 0.5rem;
  }
  a {
    color: inherit;
  }
`;

export const FormSubmit = styled.button`
  color: #afa3c0;
  font-size: 1rem;
  font-family: 'LATOREGULAR';
  background: #fff;
  height: 3rem;
  width: 100%;
  border: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  margin-bottom: -3px;
  outline: none;
`;

export const FlexLine = styled.a`
  display: flex;
  align-items: center;
  margin: 0.3rem 0;
  text-decoration: none;
`;

export const SocialIcon = styled.img`
  width: 2.5rem;
  padding-right: 0.7rem;
`;
